import React from 'react';
import Heading from "../../components/Heading";
import Container from "../../components/Container";
import Table from "./components/Table";
import SelectWrap from "../../components/SelectWrap";
import API from "../../services/API";

import { to } from "../../Utils";

class BidderSourcesConfig extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            selectedCodes: null,
            source_codes: [],
            sources: []
        }

        this.onFind = this.onFind.bind(this);
    }

    componentDidMount() {
        (async () => {
            const [ error, source_codes ] = await to(API.BidderSourcesConfig.codes());
            if (error) console.log(error)

            this.setState({ source_codes, isLoading: false })
        })()
    }

    async onFind(e) {
        e.preventDefault();

        this.setState({ isLoading: true });

        const filters = {
            code: this.state.selectedCodes
        };

        const [ error, sources ] = await to(API.BidderSourcesConfig.get(filters));
        if (error) console.error(error);

        this.setState({ isLoading: false, sources });
    }

    render() {
        const { sources, source_codes } = this.state;

        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Sources Config"/>

                <div>
                    <div>
                        <form>
                            <SelectWrap
                                values={source_codes}
                                value={this.state.selectedCodes}
                                label="Codes:"
                                name="code"
                                onChange={(e)=> this.setState({ selectedCodes: e.target.value })}
                                multi
                                required
                            />

                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ marginBottom: '1em' }}
                                onClick={this.onFind}
                            >
                                Find
                            </button>
                        </form>
                    </div>

                    <div>
                        { !!sources.length && <Table sources={this.state.sources} /> }
                    </div>
                </div>
            </Container>
        )
    }
}

export default BidderSourcesConfig;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesConfig/index.js